const hiringSteps = [
  { title: "Apply", body: "Submit your application and resume online." },
  { title: "Screening Call", body: "A short call with our talent team to learn more about you." },
  { title: "Interviews", body: "Meet the team and walk through role-specific rounds." },
  { title: "Offer & Onboarding", body: "Receive your offer and join the VerdeMobility team." },
];

export default function HiringProcess() {
  return (
    <section className="py-10 lg:py-12 bg-light-brand">
      <div className="containers-min mx-auto px-4 py-8">
        <div className="text-center mb-10">
          {/* <p className="section-eyebrow mb-2">How It Works</p> */}
          <h3 className="text-center font-gilroy">Hiring Process</h3>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {hiringSteps.map((step, i) => (
            <div className="process-step" key={step.title}>
              {i < hiringSteps.length - 1 && <div className="process-line" />}
              <div className="step-num">{i + 1}</div>
              <h3 className="text-2xl font-bold text-black font-gilroy">{step.title}</h3>
              <p className="text-lg text-gray-600">{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
